module.exports = __webpack_public_path__ + "img/Pag6.dcf2da28.png";